"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Yup = __importStar(require("yup"));

require("./validators");

var phoneMatch = /^(0)\s*(6|7)\s*([0-9]\s*){8}$/;
var ibanFields = {};

for (var index = 1; index < 8; index++) {
  ibanFields["iban_field_" + index] = {
    className: "col-5 pr-md-3 align-top",
    placeholder: index == 1 ? "FR--" : "----",
    schema: Yup.string().matches(/^[a-zA-Z0-9]+$/, "Valeur incorrecte").min(index < 7 ? 4 : 3, "Votre saisie est incomplète, merci de renseigner le champ ci-dessus.").required()
  };
}

var elements = __assign({
  last_name: {
    label: "Nom",
    placeholder: "Saisissez votre nom",
    schema: Yup.string().matches(/^[A-Z\s]+$/, "Valeur incorrecte").required("Votre saisie est incomplète, merci de renseigner le champ ci-dessus.")
  },
  first_name: {
    label: "Prénom",
    placeholder: "Saisissez votre prénom",
    schema: Yup.string().matches(/^[A-Z\s]+$/, "Valeur incorrecte").required("Votre saisie est incomplète, merci de renseigner le champ ci-dessus.")
  },
  mobile_phone: {
    className: "col-5 pl-md-3 align-top",
    label: "N° de téléphone mobile",
    placeholder: "06 .. .. .. .. ..",
    icon: "mobile-phone",
    schema: Yup.string().matches(phoneMatch, "Le numéro de téléphone n'est pas valide").required("Votre saisie est incomplète, merci de renseigner le champ ci-dessus.")
  },
  civility: {
    label: "Civilité",
    options: [{
      label: "Madame",
      value: "mrs"
    }, {
      label: "Monsieur",
      value: "mr"
    }],
    schema: Yup.string().required("Votre saisie est incomplète, merci de renseigner le champ ci-dessus.")
  }
}, ibanFields);

exports.default = elements;